import { Container } from '@material-ui/core';

import { PricingFormWrapper } from '@/components/modules/PricingCreate/components/PricingFormWrapper';
import { PricingSpecDataFormFields } from '@/components/modules/PricingCreate/components/PricingSpecDataFormFields';
import { PricingSpecDataFormSchema } from '@/components/modules/PricingCreate/schemas/PricingSpecDataFormSchema';
import { PricingSpecFormValues } from '@/components/modules/PricingEditor/types/PricingSpecFormValues';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface PricingSpecFormProps {
  onSubmit: (data: PricingSpecFormValues, pricingSpecSearchEnabled?: boolean) => Promise<void>;
  onPrev: () => void;
  loading: boolean;
}

export const PricingSpecDataForm = ({ onSubmit, onPrev, loading }: PricingSpecFormProps) => {
  return (
    <>
      <Container maxWidth={'sm'} style={{ marginLeft: 0, padding: 0 }}>
        <Font variant={'body1'} color={'textSecondary'}>
          <Text tId="CREATE_NEW_PRICING_DESCRIPTION" />
        </Font>
        <PricingFormWrapper
          formSchema={PricingSpecDataFormSchema}
          onSubmitForm={onSubmit}
          loading={loading}
          buttons={
            <StandardButton onClick={onPrev} style={{ marginRight: '8px', minWidth: '100px' }}>
              <Text tId="BACK" />
            </StandardButton>
          }
        >
          <PricingSpecDataFormFields />
        </PricingFormWrapper>
      </Container>
    </>
  );
};
